export enum LOGIN_REDIRECTION_STATE {
	LOADING = 'LOADING',
	VERIFIED = 'VERIFIED',
	FAILED = 'FAILED',
}

export enum LOGIN_REDIRECTION_FAILURE_CODE {
	ONBOARDING_URL_MISMATCH = 'ONBOARDING_URL_MISMATCH',
	INVALID_MERCHANT_TYPE = 'INVALID_MERCHANT_TYPE',
	INVALID_MERCHANT_STATE = 'INVALID_MERCHANT_STATE',
	ONBOARDING_MISSING_DETAILS = 'ONBOARDING_MISSING_DETAILS',
	UNKNOWN = 'UNKNOWN',
}
